// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2c5DN","empty":"ModalGraph_empty__3-QCS"};